import { gql, TypedDocumentNode } from '@apollo/client'

import { ALERT_FRAGMENT } from 'features/alerts/api/fragments/alert'
import { Data, Variables } from './types'

export const GET_DOMAIN_AMAZON_ALERTS: TypedDocumentNode<Data, Variables> = gql`
  ${ALERT_FRAGMENT}

  query getDomainAmazonAlerts($id: ID!) {
    node(id: $id) {
      ... on DomainAmazon {
        fieldAlerts {
          ...AlertFragment
        }
      }
    }
  }
`
